import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface EssayFilterState {
  status: string[];
  banca: number[];
  axis: string[];
  setStatus: (filtros: string[]) => void;
  setBanca: (filtros: number[]) => void;
  setAxis: (filtros: string[]) => void;
  reset: () => void;
}

export const useEssayFilterStore = create<EssayFilterState>()(
  persist(
    (set) => ({
      status: [],
      banca: [],
      axis: [],
      setStatus: (filtros: string[]) => set({ status: filtros }),
      setBanca: (filtros: number[]) => set({ banca: filtros }),
      setAxis: (filtros: string[]) => set({ axis: filtros }),
      reset: () => set({
        status: [],
        banca: [],
        axis: [],
      })
    }),
    { name: 'my-essays-filter' }
  )
);